import { isPlatformSuperAdmin } from 'pure-js/libs/isSuperUser'
import { isParticipantOrgRole } from 'pure-js/libs/organizationMembershipHelpers'
import { OrgRole, type OrganizationMembership } from 'pure-js/types/OrganizationMembership'
import type { User } from 'pure-js/types/User'

export function getActiveOrganizationId(user: User | null | undefined): string | undefined {
  return user?.activeOrganizationId ?? user?.organizations?.[0]?.organizationId ?? user?.platformDefaultOrganizationId
}

export function getActiveOrgMembership(
  user: User | null | undefined,
  organizationId?: string
): OrganizationMembership | undefined {
  const activeOrganizationId = organizationId ?? getActiveOrganizationId(user)
  if (!activeOrganizationId) return undefined
  return user?.organizations?.find((membership) => membership.organizationId === activeOrganizationId)
}

/** A platform operator acts as an org admin everywhere the UI asks for a role. */
export function getActiveOrgRole(user: User | null | undefined): OrgRole | undefined {
  if (isPlatformSuperAdmin(user)) return OrgRole.ADMIN
  return getActiveOrgMembership(user)?.role
}

/** True for every participant role, gamer and leader alike — the gamer shell, its notifications and its call surface. */
export function isParticipantRole(user: User | null | undefined): boolean {
  return isParticipantOrgRole(getActiveOrgRole(user))
}

/** True for a leader of the active organization: a participant who also gets the My people page. */
export function isLeaderRole(user: User | null | undefined): boolean {
  return getActiveOrgRole(user) === OrgRole.LEADER
}
